module.exports = __webpack_public_path__ + "static/img/bg-en.1cbcd0fa.png";